var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value-item"},[_vm._t("icon"),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }